import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const Header = styled.header`
  width: 100%;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const HeadingContainer = styled.div<{ changePassword: boolean }>`
  margin-top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  justify-content: flex-start;
  align-items: center;
`;

export const Heading = styled.h2`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  height: 50px;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  margin: 0;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    margin: -80px;
  }
`;

export const Body = styled.div`
  padding: 0 40px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  width: 83%;
`;

export const Info = styled.div`
  margin-bottom: -10px;
  margin-top: -10px;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Passwords = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  flex-grow: 10;
`;

export const ButtonContainer = styled.div`
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

export const ButtonWrapper = styled.div`
  align-items: center;
`;

export const FooterContainer = styled.footer`
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const textboxStyles: React.CSSProperties = {
  width: '100%',
  paddingTop: '5px',
  paddingBottom: '5px',
};

export const Submitted = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  p {
    text-align: center;
  }
`;
